<lds-card margin="none" padding="none">
  <div class="support">
    <h4 class="support__heading">We're here to help.</h4>
    <p class="support__text">
      Please contact your product analyst or email
      <a href="mailto:sparkplus@liberty.com.au">sparkplus@liberty.com.au</a>.
    </p>
  </div>
</lds-card>
